import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const useCreateWidgetScript = ({
  backgroundColor,
  textColor,
  actionsColor,
  freeShippingBannerBackgroundColor,
  freeShippingBannerTextColor,
  sortingType,
  store,
}) => {
  const { i18n } = useTranslation()
  const updateTimeOut = useRef()

  useEffect(() => {
    if (updateTimeOut.current) {
      clearTimeout(updateTimeOut.current)
    }

    updateTimeOut.current = setTimeout(() => {
      const script = document.createElement('script')
      script.defer = true
      const theme = encodeURIComponent(
        JSON.stringify({
          backgroundColor,
          textColor,
          actionsColor,
          freeShippingBannerBackgroundColor,
          freeShippingBannerTextColor,
          previewFreeShippingBanner: true,
          sortingType,
        })
      )
      script.src = `${import.meta.env.VITE_REVENI_SHIPPING_WIDGET}?language=${i18n.language}&storeId=${store.id}&currency=${store.currency}&countryCode=${store?.merchant?.country?.code || 'ES'}&theme=${theme}`
      const container = document.getElementById('reveni-load-widget')

      container.innerHTML = ''
      document.getElementById('reveni-shipping-widget')?.remove()

      const shippingWidgetContainer = document.createElement('div')
      shippingWidgetContainer.id = 'reveni-shipping-widget'
      container.parentNode.appendChild(shippingWidgetContainer)

      container.appendChild(script)
    }, 500)

    return () => {
      const container = document.getElementById('reveni-load-widget')
      if (container) {
        container.innerHTML = ''
      }
      document.getElementById('reveni-shipping-widget')?.remove()
    }
  }, [
    i18n.language,
    textColor,
    backgroundColor,
    actionsColor,
    freeShippingBannerBackgroundColor,
    freeShippingBannerTextColor,
    sortingType,
    store,
  ])
}

export default useCreateWidgetScript
